import { useState } from "react"
import { sendPasswordResetLink } from "../../Firebase/FirebaseAuth";
import NavBar from "../../Universal Components/NavBar/NavBar"
import "./ForgotPassword.css"

export default function ForgotPassword(){

    const [forgotten_email, set_forgotten_email] = useState(null);
    const [reset_resp, set_reset_resp] = useState(null);

    const handleSendLink = async () =>{
        const resetResp = await sendPasswordResetLink(forgotten_email);
        set_reset_resp(resetResp);
    }

    return (
        <>
            <NavBar/>
            {reset_resp && (
            <div className={`reset-response ${reset_resp.code === 200 ? "success" : "error"}`}>
                {reset_resp.result}
            </div>
            )}
            <div className="forgot-password-outer-wrapper">
                <div className="input-box-forgot-password">
                    Forgot password?
                    <div className="forgot-subtext">
                        If you signed up with Email/Password, we can send a reset link to your email. 
                        If you signed up with another provider (Google/GitHub), please contact the respective provider to reset your information.
                        You can reach customer support at studium93official@gmail.com
                    </div>

                    <input 
                        placeholder="Enter email" 
                        className="forgotten-email-input"
                        onChange={e => set_forgotten_email(e.target.value)}
                    />
                    <button className="send-forgot-link" 
                        onClick={handleSendLink}>
                        Send Link
                    </button>
                </div>
            </div>
        </>
    )
}